import * as JsonSchema from '../../utils/json-schema'

export type T = ScopesApiResponse

type ScopesApiResponse = Scope[]

type Scope = {
  id: string
  name: string
  fullName: string
  code: string
  location: Location
  ianaTimeZone: string
  allowedActions: string[]
}

type Location = {
  latitude: number // -90 to 90
  longitude: number // -180 to 180
}

const LOCATION_SCHEMA:JsonSchema.T<Location> = {
  type      : 'object',
  required  : [ 'latitude', 'longitude' ],
  properties: {
    latitude : { type: 'number', maximum: 90, minimum: -90 },
    longitude: { type: 'number', maximum: 180, minimum: -180 },
  }
}
const SCOPE_SCHEMA:JsonSchema.T<Scope> = {
  type    : 'object',
  required: [
    'id',
    'name',
    'fullName',
    'code',
    'location',
    'ianaTimeZone',
    'allowedActions',
  ],
  properties: {
    id            : { type: 'string' },
    name          : { type: 'string' },
    fullName      : { type: 'string' },
    code          : { type: 'string' },
    location      : LOCATION_SCHEMA,
    ianaTimeZone  : { type: 'string' },
    allowedActions: { type: 'array', items: { type: 'string' } },
  }
}

const SCOPE_ARRAY_SCHEMA: JsonSchema.T<ScopesApiResponse> = {
  type : 'array',
  items: SCOPE_SCHEMA
}

export const parse = JsonSchema.parserForCollection(SCOPE_ARRAY_SCHEMA, 'scopes')